// extracted by mini-css-extract-plugin
export var cardLayout = "_6y-1";
export var paginationContainer = "_6y-0";